import React from 'react';
import { Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-cream-alt border-t border-brand-gold/20 py-12 mt-20" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="flex flex-col items-center text-center space-y-6" data-id="element-45">
          <div className="font-serif text-2xl font-semibold text-brand-burgundy tracking-wide" data-id="element-46">
            María Andrea López
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600" data-id="element-47">
            <a href="#" className="hover:text-brand-burgundy transition-colors" data-id="element-48">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-brand-burgundy transition-colors" data-id="element-49">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-brand-burgundy transition-colors" data-id="element-50">
              Garantía de 30 Días
            </a>
            <a href="#" className="hover:text-brand-burgundy transition-colors" data-id="element-51">
              Contacto
            </a>
          </div>

          <div className="flex items-center justify-center text-sm text-gray-500 pt-6 border-t border-brand-gold/20 w-full max-w-md" data-id="element-52">
            <span data-id="element-53">
              © {new Date().getFullYear()} Método de las 40 Semanas de
              Conexión™.
            </span>
          </div>
          <div className="flex items-center justify-center text-xs text-brand-rose gap-1" data-id="element-54">
            Creado con <Heart className="w-3 h-3 fill-current" data-id="element-55" /> para futuras
            mamás
          </div>
        </div>
      </div>
    </footer>;
}